import { ExclamationCircleFilled, LinkOutlined } from "@ant-design/icons";
import { formItemLayout } from "Admin/Config/FormLayout";
import { IconPack } from "Admin/Config/Icon";
import {
  createProfileExperience,
  deleteProfileExperience,
  getProfileExperiences,
} from "Admin/Service/Profile";
import { handleAPIResponse } from "Admin/Utils/HandleAPIResponse";
import { LoadingListEntityProfile } from "Explore/Components";
import {
  Button,
  Empty,
  Form,
  Input,
  message,
  Modal,
  Tooltip,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import styles from "./Experiences.module.scss";
const { Paragraph, Text, Link } = Typography;
const { confirm } = Modal;

const QuotationAndCitation = ({ quotation, citationURL }) => {
  const displayText =
    quotation.length > 0
      ? quotation
      : "The information is extracted but not yet verified";
  return (
    <div>
      <Paragraph>
        <Link href={citationURL} target="_blank">
          <LinkOutlined />
        </Link>
        &nbsp;
        <Text type="secondary" style={{ fontStyle: "italic" }}>
          {displayText}
        </Text>
        <Tooltip title={citationURL}></Tooltip>
      </Paragraph>
    </div>
  );
};

const Experiences = () => {
  const [form] = Form.useForm();
  const [data, setData] = useState({
    data: [],
    isLoading: true,
    source_url: null,
  });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 10,
    totalRows: 0,
  });
  const [openAddExperienceModal, setOpenAddExperienceModal] = useState(false);
  const [openDeleteExperienceModal, setOpenDeleteExperienceModal] =
    useState(false);
  useEffect(() => {
    setData({ data: [], isLoading: true });
    getProfileExperiences(
      pagination.page - 1,
      pagination.rowsPerPage,
      (res) => {
        handleAPIResponse(res, () => {
          setData({
            data: res.data.work_experience,
            isLoading: false,
            source_url: res.data.work_experience_source_url,
          });
          if (res.data.total) {
            setPagination({
              ...pagination,
              totalRows: res.data.total,
            });
          }
        });
      }
    );
  }, [pagination.page, pagination.rowsPerPage]);

  const Experience = ({ experience }) => {
    var fromYearProcessedString = experience.from_year
      ? experience.from_year
      : "???";
    var toYearProcessedString = experience.to_year ? experience.to_year : "???";

    return (
      <div className={styles["experience-wrapper"]}>
        <div className={styles["experience"]}>
          <div className={styles["experience-info"]}>
            <p className={styles["inst-name"]}>{experience.institution}</p>
            <p>
              <span>{experience.position_title} </span>
              <span>
                ({fromYearProcessedString} - {toYearProcessedString})
              </span>
            </p>
            <QuotationAndCitation
              quotation={
                experience?.raw?.length > 0
                  ? `"...` + experience.raw.join(". ") + `..."`
                  : ""
              }
              citationURL={data.source_url}
            />
          </div>
        </div>
        <div
          className={styles["delete-experience"]}
          onClick={() => handleDeleteExperience(experience)}
        >
          {IconPack.delete_icon}
        </div>
      </div>
    );
  };
  const handleAddExperience = () => {
    createProfileExperience(form.getFieldsValue(), (res) => {
      handleAPIResponse(res, () => {
        setData({
          ...data,
          data: [form.getFieldsValue(), ...data.data],
        });
      });
    });
    setOpenAddExperienceModal(false);
  };
  const handleDeleteExperience = (experience) => {
    const payload = {
      from_year: experience.from_year,
      to_year: experience.to_year,
      institution: experience.institution,
      position_title: experience.position_title,
    };
    confirm({
      title: "Are you sure delete this honor?",
      icon: <ExclamationCircleFilled />,
      content: "This action is irreversible.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      open: openDeleteExperienceModal,
      onOk() {
        deleteProfileExperience(payload, (res) => {
          handleAPIResponse(res, () => {
            const updateList = data.data.filter((item) => item !== experience);
            setData({ data: updateList, isLoading: false });
            message.success("Delete experience successfully");
            setOpenDeleteExperienceModal(false);
          });
        });
      },
      onCancel() {
        setOpenDeleteExperienceModal(false);
      },
    });
  };
  return (
    <div className={styles["experiences"]}>
      <Modal
        title="Add honor"
        open={openAddExperienceModal}
        onOk={handleAddExperience}
        width={1000}
        onCancel={() => setOpenAddExperienceModal(false)}
      >
        <Form
          {...formItemLayout}
          form={form}
          onFinish={handleAddExperience}
          layout="vertical"
        >
          <Form.Item
            rules={[
              {
                required: true,
              },
            ]}
            label={"Institution:"}
            labelAlign="left"
            name="institution"
          >
            <Input placeholder="Please input the institution name" />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
              },
            ]}
            label={"Position:"}
            labelAlign="left"
            name="position_title"
          >
            <Input placeholder="Please input the position" />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
              },
            ]}
            label={"From year:"}
            labelAlign="left"
            name="from_year"
          >
            <Input placeholder="Please input the start year" />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
              },
            ]}
            label={"To year:"}
            labelAlign="left"
            name="to_year"
          >
            <Input placeholder="Please input the end year" />
          </Form.Item>
        </Form>
      </Modal>
      <div className={styles["add-button"]}>
        <Button type="primary" onClick={() => setOpenAddExperienceModal(true)}>
          Add experience
        </Button>
      </div>
      <LoadingListEntityProfile
        isLoading={data.isLoading}
        component={
          data?.data.length > 0 ? (
            data?.data.map((item, index) => {
              return <Experience experience={item} key={index} />;
            })
          ) : (
            <Empty description="No Experience Found." />
          )
        }
        componentNum={10}
        rows={2}
        avatar={true}
      />
    </div>
  );
};

export default Experiences;
